import { Fragment, useEffect, useRef, useState } from "react";
import { isValidArray, scrollToFocuse } from "../../../Layout/Common/common";

export const NotesContainer = ({ htmlString, location }) => {
  const [notesData, setNotesData] = useState(null);
  const [position, setPosition] = useState(null);
  const [showReadMore, setShowReadMore] = useState(false);
  const [showReadMoreValues, setShowReadMoreValues] = useState(false);
  const divref = useRef();
  useEffect(() => {
    if (htmlString) {
      // const parser = new DOMParser();
      // const doc = parser.parseFromString(htmlString, "text/html");

      setNotesData(htmlString);
    } else {
      setNotesData(null);
    }
  }, [htmlString]);
  const truncateHtml = (html, limit = 563) => {
    if (!html) return "";

    // Remove HTML tags to count characters properly
    const temp = document.createElement("div");
    temp.innerHTML = html;
    const text = temp.textContent || temp.innerText || "";

    if (text.length <= limit) return html;

    return text.substring(0, limit) + "...";
  };
  useEffect(() => {
    setPosition(location);
    setTimeout(() => {
      if (location == "top" && htmlString.length > 450) {
        setShowReadMore(true);
        setShowReadMoreValues(true);
        setNotesData(truncateHtml(htmlString, 450));
      }
    }, 2000);
  }, [location]);

  const RenderFeatureList = ({ notescations }) => {
    const clickToFcous = () => {
      const focusContainer = document.getElementById("section-descriptions");
      if (focusContainer) scrollToFocuse(focusContainer, 0, 200);
      if (showReadMoreValues) setNotesData(htmlString);
      else setNotesData(truncateHtml(htmlString, 450));
      setShowReadMoreValues(!showReadMoreValues);
    };
    return (
      <Fragment>
        <div className="proSection-title featuresListing-right">
          <h4>Notes</h4>
        </div>

        <div className={`prosection-description  ${showReadMore == true ? "text-container" : ""}`}>
          <p className="productPage-content" ref={divref}>
            {notescations}
          </p>
          {showReadMore == true && (
            <a href="#" onClick={clickToFcous} className="familyReadmore">
              {showReadMoreValues ? "Read More" : "Read Less"}
            </a>
          )}
        </div>
      </Fragment>
    );
  };

  return (
    <Fragment>
      <Fragment>
        {position && position == "top" ? (
          <RenderFeatureList notescations={notesData} />
        ) : (
          <div className="productFeature">
            <RenderFeatureList notescations={notesData} />
          </div>
        )}
      </Fragment>
    </Fragment>
  );
};
